<div class="modal-header">
  <h4 class="modal-title pull-left">Lookup Values: {{modalAutoCompleteConfig.label}}</h4>
  <button type="button" class="close pull-right btn_close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="searchbox">
    <div class="row">
      <label>Search {{modalAutoCompleteConfig.label}}</label>
      <div class="col-lg-4 col-md-12">
        <app-autocomplete [autoCompleteConfig]="modalAutoCompleteConfig"
                          (bySelect)="onAutoCompleteItemSelected($event)"
                          (searchClick)="onAutoCompleteSearchClick($event)"
                          [(valueModel)]="selectedAutoCompleteValue">
        </app-autocomplete>
      </div>
    </div>
  </div>
  <app-lookupdataview (byLoaded)="common.setLoader()" [inputParams]="listingParams"></app-lookupdataview>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary btn_ok" (click)="onOkClicked()">OK</button>
  <button type="button" class="btn btn-danger btn_cancel" (click)="bsModalRef.hide()">Cancel</button> 
</div>
